/**
 * Designed  & Developed by Faisal Nadaf
 * Contact: faisalfnadaf@gmail.com
 *
 * @format
 */

import { Navigation } from "@/components/customCopmonent/landingSection/navigation";
import { FooterSection } from "@/components/customCopmonent/landingSection/footer-section";
import CircularGallery from "@/components/customCopmonent/CircularGallery";
import DotGrid from "@/components/customCopmonent/DotGrid";
import { PageHeaderHero, PAGE_HERO_CLASS } from "@/components/customCopmonent/Text/PageHeaderHero";
import { SectionWrapper } from "../Clientele.page-primitives";
import { PageHeader } from "@/components/customCopmonent/Text/PageHeader";
import { RevealOnScroll } from "@/components/SpecialProjectsPage.primitives";
import Seo from "@/components/Seo";
import { useIsMobile } from "@/hooks/hooks/use-mobile";

import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import {
	IndustrySectionProduct,
	IndustrySectionApplication,
} from "@/components/customCopmonent/IndustryCardsAP";

// Register ScrollTrigger
if (typeof window !== "undefined") {
	gsap.registerPlugin(ScrollTrigger);
}

const SUB_INDUSTRY_IMAGES = [
	"/images/industriesPhotos/HVACSystems/SubIndustries/Central_Cooling_Plants.jpg",
	"/images/industriesPhotos/HVACSystems/SubIndustries/Chiller_Plants.webp",
	"/images/industriesPhotos/HVACSystems/SubIndustries/District_Cooling_Systems.webp",
	"/images/industriesPhotos/HVACSystems/SubIndustries/Industrial_HVAC_Systems.webp",
	"/images/industriesPhotos/HVACSystems/SubIndustries/Cooling_Towers _&_Utilities.webp",
];

const APPLICATION_IMAGES = [
	"/images/industriesPhotos/HVACSystems/Application/Chilled_Water_Cooling_Systems.webp",
	"/images/industriesPhotos/HVACSystems/Application/Condenser_Heat_Rejection.webp",
	"/images/industriesPhotos/HVACSystems/Application/Industrial_Process_Cooling.webp",
	"/images/industriesPhotos/HVACSystems/Application/District_Cooling_Applications.webp",
	"/images/industriesPhotos/HVACSystems/Application/HVAC_Utility _Cooling.webp",
	"/images/industriesPhotos/HVACSystems/Application/Thermal_Load_Managementwebp.webp",
	"/images/industriesPhotos/HVACSystems/SubIndustries/Cooling_Towers _&_Utilities.webp",
	"/images/freeDownloads/data-centers.jpg",
];

const HVACSystems = () => {
	const { t } = useTranslation();
	const isMobile = useIsMobile();

	const subIndustryTexts = t("industryPages.hvacSystems.subIndustries.items", {
		returnObjects: true,
	}) as string[];
	const applicationItems = t("industryPages.hvacSystems.applications.items", {
		returnObjects: true,
	}) as { title: string; description: string }[];

	const pageData = {
		title: t("industryPages.hvacSystems.title"),
		bgimage: "/images/header/hvac.webp",
		description: t("industryPages.hvacSystems.tagline"),
		meta: t("industryPages.hvacSystems.meta", {
			returnObjects: true,
		}) as string[],
		subIndustries: {
			title: t("industryPages.hvacSystems.subIndustries.title"),
			industries: SUB_INDUSTRY_IMAGES.map((image, i) => ({
				image,
				text: subIndustryTexts[i],
			})),
		},
		applications: {
			title: t("industryPages.hvacSystems.applications.title"),
			applications: APPLICATION_IMAGES.map((image, i) => ({
				image,
				title: applicationItems[i]?.title,
				description: applicationItems[i]?.description,
			})),
		},
	};
	return (
		<>
			<Seo
				titleKey="industryPages.hvacSystems.seo.title"
				descriptionKey="industryPages.hvacSystems.seo.description"
				path="/industries/hvac-systems"
			/>
			<Navigation />
			<SectionWrapper className={PAGE_HERO_CLASS}>
				<div className="absolute inset-0 ">
					{" "}
					<div
						className="absolute bottom-3 inset-0 opacity-35 scale-105"
						style={{
							backgroundImage: `url(${pageData.bgimage})`,
							backgroundSize: "cover",
							backgroundPosition: "center",
						}}
					/>
					<DotGrid
						dotSize={4}
						gap={15}
						baseColor="#3b0092"
						activeColor="#f09a38"
						proximity={100}
						shockRadius={200}
						shockStrength={3}
						resistance={750}
						returnDuration={1.5}
					/>
				</div>
				<PageHeaderHero
					// align="center"
					title={pageData.title}
					description={pageData.description}
					meta={pageData.meta}
				/>
			</SectionWrapper>
			<SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				{" "}
				<div className="relative flex flex-col items-center justify-center ">
					{/* ===== HEADER ===== */}
					<RevealOnScroll>
						<PageHeader
							title={pageData.subIndustries.title}
							align="center"
							className="py-6 text-center items-center "
						/>
					</RevealOnScroll>
				</div>
				<div className="relative h-[360px] sm:h-[460px] lg:h-[600px]">
					<CircularGallery
						items={pageData.subIndustries.industries}
						textColor="#000"
						borderRadius={0.05}
						bend={isMobile ? 0 : -3}
						scrollSpeed={1.5}
						scrollEase={0.05}
					/>
				</div>
			</SectionWrapper>
			<SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				<IndustrySectionApplication
					applications={pageData.applications.applications}
					title={pageData.applications.title}
				/>{" "}
			</SectionWrapper>
			{/* <SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				<IndustrySectionProduct
					applications={pageData.products.products}
					title={pageData.products.title}
					description={pageData.products.description}
				/>{" "}
			</SectionWrapper> */}
			<FooterSection />
		</>
	);
};

export default HVACSystems;
